/*
  AMAVO CLINICAL — content pages
  ------------------------------------------------------------------
  Filtering for the ingredient index and the FAQ page. Both filter
  markup that is already complete in the DOM, so with JavaScript off the
  full list is still there — which is also what a search engine sees.
*/

(() => {
  'use strict';

  // Romanian diacritics have to be folded, or searching "sensibil" misses
  // "sensibilă" and searching "acid" misses "Acid Hialuronic".
  const fold = (s) => (s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/ș|ş/g, 's')
    .replace(/ț|ţ/g, 't');

  class AmvIndex extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-amv-index-search]');
      this.list = this.querySelector('[data-amv-index-list]');
      this.counter = this.querySelector('[data-amv-index-count]');
      this.empty = this.querySelector('[data-amv-index-empty]');
      if (!this.input || !this.list) return;

      this.items = Array.from(this.list.querySelectorAll('.amv-index__item'));
      this.markers = Array.from(this.list.querySelectorAll('[data-letter]'));

      this.input.addEventListener('input', () => this.filter());
      this.filter();
    }

    filter() {
      const q = fold(this.input.value.trim());
      let shown = 0;

      this.items.forEach((item) => {
        const hit = !q ||
          fold(item.dataset.name).includes(q) ||
          fold(item.dataset.inci).includes(q);
        item.hidden = !hit;
        if (hit) shown += 1;
      });

      // A letter heading with nothing under it is noise.
      this.markers.forEach((marker) => {
        let next = marker.nextElementSibling;
        let any = false;
        while (next && !next.hasAttribute('data-letter')) {
          if (!next.hidden) { any = true; break; }
          next = next.nextElementSibling;
        }
        marker.hidden = !any;
      });

      if (this.counter) this.counter.textContent = shown ? `${shown}` : '';
      if (this.empty) this.empty.hidden = shown > 0;
    }
  }

  /* FAQ page: same idea, over accordions grouped by category. */
  class AmvFaqSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-amv-faq-search]');
      if (!this.input) return;
      this.groups = Array.from(this.querySelectorAll('[data-amv-faq-group]'));
      this.categories = Array.from(this.querySelectorAll('[data-amv-faq-category]'));
      this.items = Array.from(this.querySelectorAll('[data-amv-faq-item]'));
      this.empty = this.querySelector('[data-amv-faq-empty]');
      this.input.addEventListener('input', () => this.filter());
    }

    filter() {
      const q = fold(this.input.value.trim());
      let shown = 0;

      this.items.forEach((item) => {
        const hit = !q || fold(item.textContent).includes(q);
        item.hidden = !hit;
        if (hit) {
          shown += 1;
          // Open matches so the answer is visible, not just the question.
          if (q) item.open = true;
        } else {
          item.open = false;
        }
      });

      this.groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-amv-faq-item]:not([hidden])');
      });

      this.categories.forEach((category) => {
        let sibling = category.nextElementSibling;
        let hasVisibleQuestion = false;
        while (sibling && !sibling.matches('[data-amv-faq-category]')) {
          if (sibling.matches('[data-amv-faq-group]') && !sibling.hidden) hasVisibleQuestion = true;
          sibling = sibling.nextElementSibling;
        }
        category.hidden = !hasVisibleQuestion;
      });

      if (this.empty) this.empty.hidden = shown > 0;
    }
  }

  if (!customElements.get('amv-index')) customElements.define('amv-index', AmvIndex);
  if (!customElements.get('amv-faq-search')) customElements.define('amv-faq-search', AmvFaqSearch);
})();
